import { render, staticRenderFns } from "./devices.vue?vue&type=template&id=16365b52"
import script from "./devices.vue?vue&type=script&lang=js"
export * from "./devices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Repos\\StopRiparo_Piattaforma\\Piattaforma.Client\\wwwroot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16365b52')) {
      api.createRecord('16365b52', component.options)
    } else {
      api.reload('16365b52', component.options)
    }
    module.hot.accept("./devices.vue?vue&type=template&id=16365b52", function () {
      api.rerender('16365b52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ticket/views/devices.vue"
export default component.exports